import React, { useState } from 'react';
import Icon from 'components/AppIcon';


const initialAlerts = [
  { id: 1, type: 'critical', title: 'Missed Monthly Target', message: 'Northern Luzon missed March target by 26% on Shampoo and Body Wash. Immediate intervention required.', time: '2h ago', icon: 'AlertCircle', actionLabel: 'View Territory' },
  { id: 2, type: 'warning', title: 'Declining Account — SM Hypermarket Cebu', message: 'Toothpaste and Mouthwash orders dropped 34% over last 3 months. Risk of account loss.', time: '5h ago', icon: 'TrendingDown', actionLabel: 'View Account' },
  { id: 3, type: 'warning', title: 'Coverage Deficiency — BARMM', message: 'Only 48% of target accounts visited this month. Coverage below threshold for Soap and Lotion.', time: '1d ago', icon: 'Map', actionLabel: 'View Map' },
  { id: 4, type: 'info', title: 'Salesperson Productivity Drop', message: 'Carlo Mendoza productivity score fell to 61 (from 78 last month) on Facial Wash territory.', time: '1d ago', icon: 'User', actionLabel: 'View Profile' },
  { id: 5, type: 'success', title: 'Target Exceeded — Cebu Region', message: 'Cebu region achieved 112% of Q1 target for Deodorant and Body Wash. Best performing territory.', time: '2d ago', icon: 'CheckCircle', actionLabel: 'View Report' },
];

const typeStyles = {
  critical: { bg: 'bg-destructive/10', border: 'border-destructive/30', icon: 'text-destructive', badge: 'bg-destructive text-destructive-foreground' },
  warning: { bg: 'bg-warning/10', border: 'border-warning/30', icon: 'text-warning', badge: 'bg-warning text-warning-foreground' },
  info: { bg: 'bg-primary/10', border: 'border-primary/30', icon: 'text-primary', badge: 'bg-primary text-primary-foreground' },
  success: { bg: 'bg-success/10', border: 'border-success/30', icon: 'text-success', badge: 'bg-success text-success-foreground' },
};

export default function AlertsPanel() {
  const [alerts, setAlerts] = useState(initialAlerts);
  const [filter, setFilter] = useState('all');

  const filtered = filter === 'all' ? alerts : alerts?.filter((a) => a?.type === filter);

  return (
    <div className="card p-4 lg:p-6 table-panel-depth">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div className="flex items-center gap-2">
          <h3 className="font-heading font-semibold text-base lg:text-lg text-foreground">Performance Alerts</h3>
          <span className="px-2 py-0.5 bg-destructive text-destructive-foreground rounded-full font-caption text-xs font-bold">{alerts?.filter(a => a?.type === 'critical')?.length}</span>
        </div>
        <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
          {['all', 'critical', 'warning', 'info', 'success']?.map((f) => (
            <button key={f} onClick={() => setFilter(f)}
              className={`px-2.5 py-1 rounded-md font-caption text-xs font-medium transition-all duration-200 capitalize min-h-[28px] ${filter === f ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'}`}>
              {f}
            </button>
          ))}
        </div>
      </div>
      <div className="space-y-2 max-h-80 overflow-y-auto custom-scrollbar">
        {filtered?.map((alert) => {
          const s = typeStyles?.[alert?.type];
          return (
            <div key={alert?.id} className={`flex items-start gap-3 p-3 rounded-lg border ${s?.bg} ${s?.border}`}>
              <Icon name={alert?.icon} size={16} color="currentColor" strokeWidth={2} className={`mt-0.5 flex-shrink-0 ${s?.icon}`} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-0.5">
                  <span className="font-caption text-sm font-semibold text-foreground">{alert?.title}</span>
                  <span className={`px-1.5 py-0.5 rounded font-caption text-xs capitalize ${s?.badge}`}>{alert?.type}</span>
                  <span className="font-caption text-xs text-muted-foreground ml-auto">{alert?.time}</span>
                </div>
                <p className="font-caption text-xs text-muted-foreground line-clamp-2">{alert?.message}</p>
              </div>
              <button onClick={() => setAlerts(prev => prev?.filter(a => a?.id !== alert?.id))}
                className="flex-shrink-0 text-muted-foreground hover:text-foreground transition-colors p-1 rounded min-w-[28px] min-h-[28px] flex items-center justify-center">
                <Icon name="X" size={13} color="currentColor" strokeWidth={2.5} />
              </button>
            </div>
          );
        })}
        {filtered?.length === 0 && (
          <div className="text-center py-8">
            <Icon name="CheckCircle" size={32} color="var(--color-success)" strokeWidth={1.5} className="mx-auto mb-2" />
            <p className="font-caption text-sm text-muted-foreground">No alerts in this category</p>
          </div>
        )}
      </div>
    </div>
  );
}